import React, { useState, useEffect } from 'react';
import { Card, Table,Typography,Checkbox,Avatar,Tag } from 'antd';
import { useLocation, Link,useNavigate } from "react-router-dom";
import { BASE_URL, DateFormat } from '../Components/Constant';
import {PhoneOutlined} from '@ant-design/icons';
import dayjs from 'dayjs';
import { getUniqueColor } from '../Components/Utility';
import ListViewTable from '../Record/ListViewTable';
import ApiService from "../Components/apiService";

const ViewAllRecords = ()=>{
    const [loading,setLoading] = useState(false);
    const { Title } = Typography;
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize,setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0); // Total number of records
    const [records,setRecords] = useState(null);
    const navigate = useNavigate();
    const [sanitizedRecords,setSanitizedRecords] = useState([]);
    const location = useLocation();
    const [activeCurrencies,setActiveCurrencies] = useState([]);
    
    const { metadata,keyword,objName,isGlobalSearch } = location.state || {};
    useEffect(() => {
        fetchSingleObjectRecords(1,10);
    }, []);

    const metadataColumns = metadata?.map((meta) => ({
        title: meta.label,
        dataIndex: meta.name,
        key: meta.name,
      }));
    
      const getConvertedValue = (amount, fromCode, toCode) => {
        const parsedAmount = parseFloat(amount);
      
        // Check for invalid or empty amount
        if (isNaN(parsedAmount) || fromCode === toCode) {
          return isNaN(parsedAmount) ? '0.00' : parsedAmount.toFixed(2);
        }
        const fromCurrency = activeCurrencies.find(c => c.iso_code === fromCode);
        const toCurrency = activeCurrencies.find(c => c.iso_code === toCode);
        console.log('activeCurrencies isss',activeCurrencies);
        console.log('fromCurrency',fromCurrency,toCurrency);
        if (!fromCurrency || !toCurrency || !fromCurrency.conversion_rate || !toCurrency.conversion_rate) {
          return '0.00';
        }
      
        const inCorporate = parsedAmount / fromCurrency.conversion_rate;
        const converted = inCorporate * toCurrency.conversion_rate;
      
        return converted.toFixed(2);
      };
    const fetchSingleObjectRecords = async ( page = 1, size = pageSize) => {
      setLoading(true);
  
      const offsetValue = (page - 1) * size;
      const limit = size;
  
      try {
          // Create the API service instance
          const apiServiceForSearch = new ApiService(
              `${BASE_URL}/search_specific/${objName}/${keyword}/${limit}/${offsetValue}`,
              { 'Content-Type': 'application/json' },
              'GET'
          );
  
          // Make the API call
          const searchResponse = await apiServiceForSearch.makeCall();
  
          // Update the state with the fetched records
          if (searchResponse.records) {
              setRecords(searchResponse.records);
              // setAllRecords(searchResponse.records);
          } else {
              setRecords(searchResponse);
              // setAllRecords(searchResponse);
          }
          const sanitizedResults = searchResponse.records?.map(item => {
            // Create a new object excluding empty object fields
            return Object.fromEntries(
                Object.entries(item)?.filter(([key, value]) => {
                    return !(typeof value === 'object' && value !== null && Object.keys(value).length === 0);
                })
            );
        });
          setSanitizedRecords(sanitizedResults);
          setTotalRecords(searchResponse.total); // Update total records for pagination
      } catch (err) {
          console.error(err);
  
          const errorMessage = err && typeof err === 'object'
              ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
              : 'Failed to fetch records due to an unknown error';
        } finally {
          setLoading(false);
      }
  
      setCurrentPage(page);
      setPageSize(size);
  };
  
  const handleLabelClick = (record) => {
    if (record._id) {
      navigate(`/record/${objName}/${record._id}`);
    } else {
    }
  };

  const fetchCurrency = async () => {
    try {
        setLoading(true);
        const apiService = new ApiService(`${BASE_URL}/mt_currencies`, {
            'Content-Type': 'application/json',
        }, 'GET');
        const response = await apiService.makeCall();
        console.log('responseresponse:',response);
        setActiveCurrencies(response);
    } catch (err) {
        console.error("Error fetching metadata:", err);
    }finally{
        setLoading(false);
    }
}
return(
    
    <Card>
        <Title level={3} style={{ marginTop: '10px' }}>{objName} Results</Title>
        <ListViewTable getConvertedValue={getConvertedValue} fetchCurrency = {fetchCurrency} setLoading={setLoading} loading={loading} pageSize = {pageSize} currentPage ={currentPage} handleLabelClick={handleLabelClick} fetchSingleObjectRecords={fetchSingleObjectRecords} fieldsData={metadata} totalRecords={totalRecords}  records= {sanitizedRecords} setPageSize={setPageSize} isGlobalSearch={isGlobalSearch}/>
    </Card>
)}
export default ViewAllRecords;